module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Bitcoin-12193418ea745ff8dd3b2422388ebfa0.svg";